export default function SaleReceipt({ sale, onClose }) {
  if (!sale) return null;

  const businessName = localStorage.getItem("user_name") || "My Business";
  const items = sale.items || [];

  const receiptLines = items.map(item => {
    const name = item.product_name || "Item";
    const price = (item.unit_price || 0) * (item.quantity || 1);
    return `${name} x${item.quantity} = ₦${price.toLocaleString()}`;
  }).join("\n");

  const receiptText = `*${businessName} — Receipt*
━━━━━━━━━━━━━━━━
Date: ${new Date(sale.created_at).toLocaleDateString("en-NG", {
    day: "numeric", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", timeZone: "Africa/Lagos"
  })}
Payment: ${(sale.payment_method || "").toUpperCase()}
━━━━━━━━━━━━━━━━
${receiptLines}
━━━━━━━━━━━━━━━━
*TOTAL: ₦${(sale.total_amount || 0).toLocaleString()}*

Thank you for your patronage! 🙏
Powered by MartSense`;

  const handleWhatsAppShare = () => {
    const encoded = encodeURIComponent(receiptText);
    const phone = (sale.customer_phone || "").replace(/\D/g, "");
    if (phone) {
      window.open(`https://wa.me/${phone}?text=${encoded}`, "_blank");
    } else {
      window.open(`https://wa.me/?text=${encoded}`, "_blank");
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(receiptText).then(() => {
      alert("Receipt copied to clipboard");
    }).catch(() => {
      alert("Copy failed — please copy manually");
    });
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.header}>
          <h2 style={s.title}>Sale Receipt</h2>
          <button onClick={onClose} style={s.closeBtn}>✕</button>
        </div>

        <div style={s.receipt}>
          <p style={s.bizName}>{businessName}</p>
          <p style={s.date}>
            {new Date(sale.created_at).toLocaleDateString("en-NG", {
              day: "numeric", month: "short", year: "numeric",
              hour: "2-digit", minute: "2-digit", timeZone: "Africa/Lagos"
            })}
          </p>
          <div style={s.divider} />
          {items.map((item, i) => (
            <div key={i} style={s.itemRow}>
              <span style={s.itemName}>
                {item.product_name || "Item"} x{item.quantity}
              </span>
              <span style={s.itemAmount}>
                ₦{((item.unit_price || 0) * (item.quantity || 1)).toLocaleString()}
              </span>
            </div>
          ))}
          <div style={s.divider} />
          <div style={s.totalRow}>
            <span style={s.totalLabel}>TOTAL</span>
            <span style={s.totalAmount}>
              ₦{(sale.total_amount || 0).toLocaleString()}
            </span>
          </div>
          <p style={s.payment}>
            Payment: {(sale.payment_method || "").toUpperCase()}
          </p>
          {sale.customer_phone && (
            <p style={s.customerPhone}>Customer: {sale.customer_phone}</p>
          )}
          <p style={s.thanks}>Thank you for your patronage! 🙏</p>
          <p style={s.powered}>Powered by MartSense</p>
        </div>

        <div style={s.actions}>
          <button onClick={handleWhatsAppShare} style={s.whatsappBtn}>
            💬 Share on WhatsApp
          </button>
          <button onClick={handleCopy} style={s.copyBtn}>
            📋 Copy Receipt
          </button>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)",
    zIndex: 600, display: "flex", alignItems: "center",
    justifyContent: "center", padding: "20px",
  },
  modal: {
    background: "#0f1a1a", border: "1px solid #1e3333",
    borderRadius: "16px", padding: "24px",
    width: "100%", maxWidth: "400px",
    maxHeight: "90vh", overflowY: "auto",
  },
  header: {
    display: "flex", justifyContent: "space-between",
    alignItems: "center", marginBottom: "20px",
  },
  title: { fontSize: "18px", fontWeight: "700", color: "#e8f5f5" },
  closeBtn: {
    background: "none", border: "none",
    color: "#5a8a8a", fontSize: "20px", cursor: "pointer",
  },
  receipt: {
    background: "#162424", borderRadius: "10px",
    padding: "20px", marginBottom: "20px",
  },
  bizName: {
    fontSize: "16px", fontWeight: "700", color: "#2ec4b6",
    marginBottom: "4px", textAlign: "center",
  },
  date: {
    fontSize: "12px", color: "#5a8a8a",
    marginBottom: "12px", textAlign: "center",
  },
  divider: { borderTop: "1px dashed #1e3333", margin: "12px 0" },
  itemRow: {
    display: "flex", justifyContent: "space-between",
    marginBottom: "8px",
  },
  itemName: { fontSize: "13px", color: "#e8f5f5" },
  itemAmount: { fontSize: "13px", color: "#e8f5f5" },
  totalRow: {
    display: "flex", justifyContent: "space-between",
    marginBottom: "8px",
  },
  totalLabel: { fontSize: "15px", fontWeight: "700", color: "#e8f5f5" },
  totalAmount: { fontSize: "15px", fontWeight: "700", color: "#2ec4b6" },
  payment: { fontSize: "12px", color: "#5a8a8a", marginTop: "8px" },
  customerPhone: { fontSize: "12px", color: "#5a8a8a", marginTop: "4px" },
  thanks: {
    fontSize: "13px", color: "#e8f5f5",
    textAlign: "center", marginTop: "12px",
  },
  powered: {
    fontSize: "11px", color: "#5a8a8a",
    textAlign: "center", marginTop: "4px",
  },
  actions: { display: "flex", flexDirection: "column", gap: "12px" },
  whatsappBtn: {
    background: "#25D366", border: "none", borderRadius: "10px",
    padding: "14px", fontSize: "15px", fontWeight: "700",
    color: "white", cursor: "pointer", fontFamily: "inherit",
  },
  copyBtn: {
    background: "none", border: "1px solid #1e3333",
    borderRadius: "10px", padding: "12px", fontSize: "14px",
    fontWeight: "600", color: "#5a8a8a",
    cursor: "pointer", fontFamily: "inherit",
  },
};